<div class="container-fluid d-flex align-items-center justify-content-between p-3 border-bottom">
  <img
    class="logo"
    [style.visibility]="quickscan.config.value?.dok?.image ? 'visible' : 'hidden'"
    src="assets/images/{{ quickscan.config.value?.dok?.image }}"
    style="width: auto"
  />
  <div class="d-flex">
    <img class="logo" src="assets/images/logo-anteagroup.svg" />
    <div class="currentUser d-flex align-items-center mx-4" [style.opacity]="username?.length ? '1' : '0'">
      <mat-icon class="headerIcon">person</mat-icon>
      <span>Welkom, {{ username }}</span>
    </div>
  </div>
  <div class="d-flex gap-3">
    @if (quickscan.config.value?.dok?.machineManagement && machines.config) {
      <button mat-stroked-button (click)="machines.open()">
        <span>Machinebeheer</span>
      </button>
    }
    @if (isManager) {
      <button mat-stroked-button (click)="toQuickscans()">
        <mat-icon>public</mat-icon>
        <span>Quickscans</span>
      </button>
    }
    @if (fromPortal) {
      <button mat-stroked-button (click)="returnPortal()">
        <mat-icon>keyboard_return</mat-icon>
        <span>Terug naar portaal</span>
      </button>
    }

    <!-- <button mat-stroked-button class="ms-2" (click)="logoutUser()">
      <mat-icon>logout</mat-icon>
      <span>Uitloggen</span>
    </button> -->
  </div>
</div>
